import { render, staticRenderFns } from "./teamManageDetail.vue?vue&type=template&id=0b63231c&scoped=true&"
import script from "./teamManageDetail.vue?vue&type=script&lang=js&"
export * from "./teamManageDetail.vue?vue&type=script&lang=js&"
import style0 from "./teamManageDetail.vue?vue&type=style&index=0&id=0b63231c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b63231c",
  null
  
)

export default component.exports